export default class CustomerTypeHandler {
  constructor(context = "default") {
    this.context = context;
    this.init();
  }

  init() {
    // Get all customer type selects on the page
    document.querySelectorAll('[id$="_customer_type"]').forEach((select) => {
      this.setupCustomerTypeSelect(select);
    });
  }

  setupCustomerTypeSelect(select) {
    const addressType = select.id.split("_")[0]; // Get billing/shipping prefix

    // Set up input restrictions for ID fields
    this.setupNumberOnlyInput(`${addressType}_turkish_id_num`, 11);
    this.setupNumberOnlyInput(`${addressType}_tax_id_num`, 10);

    // Add change handler
    select.addEventListener("change", () =>
      this.handleCustomerTypeChange(select)
    );

    // Initial state setup
    this.handleCustomerTypeChange(select);
  }

  handleCustomerTypeChange(select) {
    const addressType = select.id.split("_")[0];
    const form = select.closest("form");
    if (!form) return;

    const container = form.querySelector(`.${addressType}-section`) || form;
    const fields = this.getFields(container, addressType);

    if (!this.validateFields(fields)) {
      console.error(`Missing required fields for ${addressType}`);
      return;
    }

    this.updateFieldsVisibility(select.value, fields);
  }

  getFields(container, addressType) {
    return {
      turkishIdField: container
        .querySelector(`[id="${addressType}_turkish_id_num"]`)
        ?.closest(".form-row"),
      taxIdField: container
        .querySelector(`[id="${addressType}_tax_id_num"]`)
        ?.closest(".form-row"),
      turkishIdInput: container.querySelector(
        `[name="${addressType}_turkish_id_num"]`
      ),
      taxIdInput: container.querySelector(`[name="${addressType}_tax_id_num"]`),
    };
  }

  validateFields(fields) {
    return Object.values(fields).every((field) => field !== null);
  }

  updateFieldsVisibility(customerType, fields) {
    const { turkishIdField, taxIdField, turkishIdInput, taxIdInput } = fields;

    if (customerType === "bireysel") {
      turkishIdField.classList.remove("hidden");
      taxIdField.classList.add("hidden");
      turkishIdInput.required = true;
      turkishIdInput.disabled = false;
      taxIdInput.required = false;
      taxIdInput.disabled = true;
      taxIdInput.value = "";
    } else {
      turkishIdField.classList.add("hidden");
      taxIdField.classList.remove("hidden");
      turkishIdInput.required = false;
      turkishIdInput.disabled = true;
      taxIdInput.required = true;
      taxIdInput.disabled = false;
      turkishIdInput.value = "";
    }
  }

  setupNumberOnlyInput(fieldId, maxLength) {
    const input = document.getElementById(fieldId);
    if (!input) return;

    const inputHandler = function (e) {
      if (!/^\d*$/.test(this.value)) {
        this.value = this.value.replace(/[^\d]/g, "");
      }
      if (this.value.length > maxLength) {
        this.value = this.value.slice(0, maxLength);
      }
    };

    input.addEventListener("input", inputHandler);
    input.addEventListener("keypress", (e) => {
      if (!/^\d*$/.test(e.key) || input.value.length >= maxLength) {
        e.preventDefault();
      }
    });
    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const pastedText = (e.clipboardData || window.clipboardData).getData(
        "text"
      );
      const numbersOnly = pastedText.replace(/[^\d]/g, "").slice(0, maxLength);
      input.value = numbersOnly;
    });
  }
}
